<template>
  <el-container>
    <div class="header">
      <publicBreadCrumb :breadList="breadList"/>
      <publicExpandSearch padBottom="0px" :searchList='searchList' :rightEventList="rightEventList" @rightFunc='rightFunc' v-on:getSearchObj='getSearchObj'></publicExpandSearch>
    </div>
    <el-main class="bottom-tabel">
      <el-table :data="tableData" :row-class-name='bindRowClass' :header-cell-style="{
			  background:'#FAFAFA',
			  fontWeight: 'bold',
			  color: '#333333',
			  fontSize:'14px'
			}">
        <el-table-column prop="name" label="互医机构名称">
        </el-table-column>
        <el-table-column prop="bindHospitalCount" label="绑定机构">
        </el-table-column>
        <el-table-column prop="wxAppletName" label="绑定小程序">
        </el-table-column>
        <el-table-column prop="supervisionCode" label="关联监管">
        </el-table-column>
        <el-table-column prop="supportHospitalName" label="依托医院">
        </el-table-column>
        <el-table-column prop="lastCheckTime" label="上次校验时间">
          <template slot-scope="scope">
            {{ scope.row.lastCheckTime|filterValgang }}
          </template>
        </el-table-column>
        <el-table-column prop="applyTime" label="申请时间">
          <template slot-scope="scope">
            {{ scope.row.applyTime|filterValgang }}
          </template>
        </el-table-column>
        <el-table-column prop="platformState" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.platformState==0">启用</span>
            <span v-if="scope.row.platformState==1">停用</span>
            <span v-if="scope.row.platformState==2">过期停用</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            <el-button @click="checkDetail(scope.row)" type="text" size="small">
              编辑
            </el-button>
            <el-button @click="clickDisable(scope.row)" v-if="scope.row.platformState =='0' " type="text" size="small">
              停用
            </el-button>
            <el-button @click="clickEnable(scope.row)" v-if="scope.row.platformState =='1' " type="text" size="small">
              启用
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchParams.current" :page-size="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-main>
  </el-container>
</template> 
<script>
import { getPlateFormList, disable, enable } from "./api";
export default {
  data() {
    return {
      rightEventList: [{ eventName: "新增", eventValue: 1 }],
      breadList:[{name:'机构组织'},{name:'互医机构'}],
      // searchType: "",
      searchList: [
        {
          label: "绑定小程序",
          paramName: "wxAppletName",
          inputType: "input"
        },
        {
          label: "互医机构名称",
          paramName: "platformName",
          inputType: "input"
        },
        {
          label: "依托医院",
          paramName: "supportHospitalName",
          inputType: "input"
        },
        {
          label: "上次校验时间",
          paramName: "timeRange",
          inputType: "datetimerange",
          paramstartTime: "lastCheckTimeStart",
          paramEndTime: "lastCheckTimeEnd"
        },
        {
          label: "状态",
          paramName: "platformState",
          inputType: "select",
          optionData: [
            { value: 0, label: "启用" },
            { value: 1, label: "停用" },
            { value: 2, label: "过期停用" }
          ]
        }
      ],
      searchParams: {
        current: 1,
        size: 10
      },
      total: 0,
      tableData: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.addClick()
      }
    },
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };   
      this.getList();
    },
    bindRowClass(row) {
      if (row.row.platformState == "2") {
        return "setBackground";
      }
    },
    getList() {
      getPlateFormList(this.searchParams).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    clickDisable(row) {
      disable(row.id).then(res => {
        this.getList();
      });
    },
    clickEnable(row) {
      enable(row.id).then(res => {
        this.getList();
      });
    },
    checkDetail(row, replay) {
      this.$router.push({
        path: "/addmedicalmutual",
        query: { id: row.id }
      });
    },
    addClick() {
      this.$router.push({ path: "/addmedicalmutual" });
    },
    handleSizeChange(val) {
      this.searchParams.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.getList();
    }
  }
};
</script>
<style>
.el-table tr.setBackground {
  background: #f5f7fa;
}
</style>
<style scoped lang="less">
.el-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.float-right {
  float: right;
}
.a-tag {
  border-radius: 11px;
  margin-right: 15px;
}

.header {
  background-color: #fff;
  margin-bottom: 16px;
  padding: 0 24px;
  .text {
    margin-bottom: 16px;
    color: #333333;
    font-size: 14px;
    line-height: 22px;
    padding-top: 20px;
    span:nth-child(2) {
      color: #333;
    }

    span:nth-child(1) {
      color: #999;
    }
  }
}

.bottom-tabel {
  background-color: #fff;
  padding: 16px 17px 0;
  margin: 0 15px;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}

/deep/.el-select {
  width: 100%;
}
</style>
